export const LandingPageRoutes = {
  DASHBOARD: "/landing-pages/dashboard",
  LIST: "/landing-pages",
  DETAIL: "/landing-pages/:landingPageId",
  EDITOR: "/landing-pages/:landingPageId/editor",
} as const;

// Static segments outrank :landingPageId in React Router, so these never resolve as a page id.
export const SharedComponentRoutes = {
  LIST: "/landing-pages/shared-components",
  CREATE: "/landing-pages/shared-components/new",
  EDIT: "/landing-pages/shared-components/:sharedComponentId",
} as const;
